import * as React from 'react';

import Slider from '@mui/material/Slider';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';

import {useFormContext} from 'react-hook-form';

import { Controller } from "react-hook-form"

export default function FormSlider({name,label,marks,labelProps = {},containerProps = {},rules = {},required,...props}) {

    const {control } = useFormContext();

    const requiredDefaultRule = required ? { required: { value: true, message: "This field is required" } } : {};
    rules = { ...requiredDefaultRule, ...rules };

    const labelComp = (typeof label === "string") ? <Typography variant="body1" {...labelProps}>{label}</Typography> : label;

    return (

        <Controller
            render={({field: {onChange, value, onBlur}}) =>(
                <Box sx={{width: "90%"}} {...containerProps}>
                    {labelComp}
                    <Slider 
                        aria-label={label} 
                        marks={marks} 
                        className="EwpSlider"
                        valueLabelDisplay="off"  
                        value={value}
                        onChange={onChange}
                        {...props} 
                    />
                </Box>

            )}
            name={name}
            control={control}
            rules={rules}
        />



    )
    
};